/*
 * @Author: yidan.chen
 * @Date: 2025-04-24 10:36:27
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-04-24 10:51:18
 */

import React from 'react'
import { Stack, Box, Typography, TypographyProps } from '@mui/material'

export interface StatusTextProps {
  type?: 'success' | 'warning' | 'default' | 'info' | 'blue'
  statusText: React.ReactNode
  customColor?: string
  size?: 'small' | 'medium'
  fontVariant?: TypographyProps['variant']
}

const colorMap = {
  success: 'secondary.dark',
  warning: 'warning.main',
  default: 'rgba(0, 0, 0, 0.56)',
  info: 'primary.main',
  blue: '#1EC0ED'
}

const StatusText: React.FC<StatusTextProps> = ({
  statusText,
  type,
  customColor,
  size = 'medium',
  fontVariant = 'body4' as TypographyProps['variant']
}) => {
  const dotSize = size === 'small' ? 6 : 8

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Box
        sx={{
          width: dotSize,
          minWidth: dotSize,
          height: dotSize,
          minHeight: dotSize,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: customColor || colorMap[type || 'default']
        }}
      />
      <Typography variant={fontVariant} component='div'>
        {statusText}
      </Typography>
    </Stack>
  )
}

export default StatusText
